<template>
  <div class="home section contrast-section">
    <div class="container">
      <div class="section-content">
        <div class="has-text-centered">
          <div class="logo-wrapper">
            <img src="@/assets/logo.svg" alt="">
          </div>
        </div>
        <br>
        <div class="box inner-section">
          <h2 class="is-size-5 has-text-weight-semibold">Login</h2>
          <br>
          <div>
            <div class="columns">
              <div class="column">
                <TextField
                  :label="'Email'"
                  :type="'email'"
                  :placeholder="'example@example.com'"
                  :message="emailMessage"
                  :extraClass="emailMessage ? emailMessage.class : ''"
                  @changedValue="saveEmail"
                />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <TextField
                  :label="'Password'"
                  :type="'password'"
                  :placeholder="'Type in a password'"
                  :message="passwordMessage"
                  :extraClass="passwordMessage ? passwordMessage.class : ''"
                  @changedValue="savePassword"
                />
              </div>
            </div>
            <div class="level mt is-mobile">
              <div class="level-left">
                <router-link
                  :to="{ name: 'recover-password' }"
                  class="has-text-grey-dark"
                >
                  Forgot password?
                </router-link>
              </div>
              <div class="level-right">
                <a
                  href="#"
                  :class="{ 'is-loading': submitting }"
                  class="button is-warning has-text-weight-bold level-item"
                  :disabled="submitting"
                  @click.prevent="submitForm"
                >Login</a>
              </div>
            </div>
          </div>
        </div>
        <div class="has-text-centered disclaimer">
          <p class="is-size-7">© {{ currentYear }} Global Martial Arts University and Hodgy LLC. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/inputs/TextField'
import inputMessages from '@/configs/inputMessages'
import redirectMixin from '@/mixins/redirects'
import emailValidator from 'email-validator'

import Auth from '@/helpers/auth'

export default {
  name: 'Login',
  metaInfo: {
    title: `Login - ${process.env.VUE_APP_PAGE_TITLE}`
  },
  mixins: [redirectMixin],
  components: {
    TextField
  },
  data () {
    return {
      email: '',
      password: '',
      emailMessage: false,
      passwordMessage: false,
      //  State
      submitting: false
    }
  },
  mounted () {
    const user = Auth.getUser()
    if (user !== null) {
      this.redirectUser(user)
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    },
    isValid () {
      return (
        this.email.length > 0 &&
        emailValidator.validate(this.email) &&
        this.password.length > 0
      )
    }
  },
  methods: {
    saveEmail (value) {
      if (value.trim().length > 0) {
        if (emailValidator.validate(value)) {
          this.email = value.trim()
          this.emailMessage = false
        } else {
          this.emailMessage = inputMessages.emailFormat
        }
      } else {
        this.emailMessage = inputMessages.required
      }
    },
    savePassword (value) {
      value = value.trim()
      if (value.length > 0) {
        this.password = value
        this.passwordMessage = false
      } else {
        this.passwordMessage = inputMessages.required
      }
    },
    submitForm () {
      this.submitting = true

      let isValid = this.isValid

      this.emailMessage = this.passwordMessage = false

      if (this.email.length === 0) {
        this.emailMessage = inputMessages.required
      }

      if (this.password.length === 0) {
        this.passwordMessage = inputMessages.required
      }

      this.submitting = isValid

      if (isValid) {
        this.$store
          .dispatch('auth/LOGIN_USER', {
            email: this.email,
            password: this.password
          })
          .then(res => {
            this.submitting = false
            if ('error' in res.data) {
              this.$toasted.error(res.data.error)
            } else {
              Auth.saveTokens(res.data)
              Auth.setHeader(this, res.data.token)
              Auth.saveUser(res.data.user)

              this.$store.commit('users/saveCurrentUser', res.data.user)

              this.redirectUser(res.data.user)
            }
          })
          .catch(err => {
            console.log(err)
            this.$toasted.error('Server error')
            this.submitting = false
          })
      }
    }
  }
}
</script>
